var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconRocket = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 24,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.747 17.483a8.948 8.948 0 0 1 10.44-14.4M2.608 17.419C1.471 19.41 1.09 20.957 1.733 21.6c.975.974 4.025-.403 7.558-3.204m4.043-.708-3.356-3.356m3.356 3.356 7.459-7.46a4.74 4.74 0 0 0 1.249-2.206l.48-1.92a.79.79 0 0 0-.96-.959l-1.919.482a4.74 4.74 0 0 0-2.205 1.247l-7.46 7.46m3.356 3.356.916 2.75a.395.395 0 0 0 .656.154l.958-.958a3.17 3.17 0 0 0 .766-3.246l-.498-1.5zm-3.356-3.356-2.749-.916a.395.395 0 0 1-.155-.657l.959-.958a3.17 3.17 0 0 1 3.245-.766l1.5.5z"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 24,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.747 17.483a8.948 8.948 0 0 1 10.44-14.4M2.608 17.419C1.471 19.41 1.09 20.957 1.733 21.6c.975.974 4.025-.403 7.558-3.204m4.043-.708-3.356-3.356m3.356 3.356 7.459-7.46a4.74 4.74 0 0 0 1.249-2.206l.48-1.92a.79.79 0 0 0-.96-.959l-1.919.482a4.74 4.74 0 0 0-2.205 1.247l-7.46 7.46m3.356 3.356.916 2.75a.395.395 0 0 0 .656.154l.958-.958a3.17 3.17 0 0 0 .766-3.246l-.498-1.5zm-3.356-3.356-2.749-.916a.395.395 0 0 1-.155-.657l.959-.958a3.17 3.17 0 0 1 3.245-.766l1.5.5z"
  }));
});
export default SvgIconRocket;
export const raw = __webpack_public_path__ + "static/media/IconRocket.009d9de0b3e15e7ac03c10b793d49109.svg";